import '../../resources/css/layout/LoginLayout.scss';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { toOtherPage, clearErrMsg, LOGIN_SUCCESS, LOGIN_FAIL } from '../../actions/login/index';
import { doActivePage } from '../../actions/menu/index';
import { forwardDashboard } from '../../actions/dashboard/index';
import LoginForm from '../../components/login/LoginForm';
import ModalForgotPwd from '../../components/login/ModalForgotPwd';
import Loading from '../../components/common/Loading';

class LoginLayout extends Component {

  componentDidMount() {
    const { errMsg, clearErrMsg } = this.props;

    if (errMsg) {
        alert(errMsg);
        clearErrMsg();
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { forwardDashboard, status, doActivePage, toOtherPage, errMsg, clearErrMsg } = this.props;

    if (prevProps.status !== status) {
      if (status === LOGIN_SUCCESS) {
        forwardDashboard();
        doActivePage('HoodList');
        toOtherPage();
      } else if (status === LOGIN_FAIL) {
        if (errMsg) {
            alert(errMsg);
            clearErrMsg();
        }
      }
    }
  }

  render() {
    const { status, loading } = this.props;
    
    if (status === LOGIN_SUCCESS) {      
      return (
        <Redirect to={{
          pathname: '/HoodList'
        }}/>
      );
    }

    return (
      <div className='area-login-page'>
        <Row>
          <Col sm={12}>
            <div className='area-login-bg' >
              <div className='area-logo'>
                &nbsp;
                <span className='icon-logo-big'/>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={3} xl={4}>&nbsp;</Col>
          <Col md={6} xl={4}>          
            <LoginForm></LoginForm>
            <Loading loading={loading} center={true}></Loading>
          </Col>
          <Col md={3} xl={4}>&nbsp;</Col>
        </Row>
        <Row>
          <Col sm={12}>
            <div className='area-footer' >
              <div className='area-company-info-tip'>Designed by Gemtek Technology Co Ltd.</div>
            </div>
          </Col>
        </Row>
        <ModalForgotPwd></ModalForgotPwd>  
      </div>      
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const errMsg = ownProps.location.state ? ownProps.location.state.errMsg : null;

  return {
    errMsg: errMsg || state.logindReducers.errMsg,
    status: state.logindReducers.status,
    loading: state.logindReducers.loading    
  }
}

export default connect(
  mapStateToProps,
  { clearErrMsg, forwardDashboard, doActivePage, toOtherPage }
)(LoginLayout)